import { createApp } from 'vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { createPinia } from 'pinia';
import "@/scss/app.scss";
// import VueTippy from 'vue-tippy'
import * as log from 'loglevel';
const prefix = require('loglevel-plugin-prefix');
import App from './App.vue';
import { registerGlobalComponents } from './components/global-components';
/** create app */
const app = createApp(App);
// make v-focus usable in all components
//
// app.directive('scroll', {
// // @ts-ignore
//     inserted: function (el, binding) {
//         const onScrollCallback = binding.value;
//         window.addEventListener('scroll', () => onScrollCallback());
//     }
// });
// import VueLoading from 'vue-loading-overlay';
import i18n from './i18n';
app.use(i18n).provide('i18n', app.config.globalProperties.$t);
registerGlobalComponents(app);
// Day JS
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);
// sanitize html
import VueSafeHTML from 'vue-safe-html';
// Toast
import Toaster from "@meforma/vue-toaster";
import { createToaster } from "@meforma/vue-toaster";
// logger + prefix plugin
const logger = log;
const logLevel = process.env.VUE_APP_LOGLEVEL;
// @ts-ignore
logger.setLevel(logLevel);
prefix.reg(logger);
prefix.apply(logger, {});
app.config.globalProperties.$logger = logger;
app.config.globalProperties.$dayjs = dayjs;
// mocking
if (process.env.VUE_APP_MOCK_ENABLED === 'true') {
    if (process.env.NODE_ENV === 'production') {
        logger.error('Warning: Mock is enabled while application is running in production mode!');
    }
    else {
        logger.warn('API Mocking is enabled (process.env.VUE_APP_MOCK_ENABLED = true)');
    }
}
else {
    logger.warn('API Mocking is disabled (process.env.VUE_APP_MOCK_ENABLED = false)');
}
app.use(router);
// app.use(VueLoading)
app.use(VueAxios, axios);
app.use(createPinia());
app.use(VueSafeHTML, { allowedTags: ['a', 'strong', 'em', 'u'] });
// app.use(VueTippy, {
//     defaultProps: { placement: 'bottom', theme: '', duration: [300, 300] },
// })
// for external use in js files, check @utils/toast.util.js
const toastOptions = { type: 'error', position: 'top', maxToasts: 1, duration: 2200 };
app.use(Toaster, toastOptions).provide('toast', app.config.globalProperties.$toast);
// for use outside of Vue components
const toast = createToaster(toastOptions);
app.provide('axios', app.config.globalProperties.axios); // provide 'axios'
app.mount('#app');
// global namespace to allow communicate from vanilla js to the messenger's vue instance
window['_rpc'] = {
    methods: app._component['components'].RpcCalls.methods,
    globalProps: app._context.app.config.globalProperties
};
export { logger, dayjs, i18n, toast };
